import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"

import { HISTORICAL_URL } from 'app/@common/constants'


export default function SelectHotelsHistorical({ ...props }) {

    const myProps = {
        urlAjax: HISTORICAL_URL.HOTEL_CITY,
        placeholder: 'Hotels',
        icon: { icon: 'map-marker' },
        isMulti: true,
        isDisabled: !props.location,
        ...props.location && { extraParams: {
            city: props.location
        }},
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}